import { useCurrentClientAtom } from 'atoms';
import { useMemo } from 'react';

const TOP_COMP_INTEL_BRANDS = [
  'competitor329',
  'competitor343',
  'competitor471',
  'competitor540',
  'competitor17',
  'competitor470',
  'competitor308',
  'competitor162',
  'competitor15',
  'competitor190',
  'competitor109',
  'competitor31',
  'competitor66',
  'competitor142',
  'competitor313',
  'competitor126',
  'competitor545',
  'competitor125',
  'competitor599',
  'competitor453',
];

export const useIsDemo = () => {
  const [{ current_client }] = useCurrentClientAtom();

  const isDemo = useMemo(
    () => current_client.toLowerCase() === 'demo - us',
    [current_client]
  );

  return { isDemo, topCompetitors: TOP_COMP_INTEL_BRANDS };
};
